import clsx from 'clsx'

const DEFAULT_OPTIONS = {
  layout: 'full',
  hideQuickAdd: false,
  hideSwatches: false,
  hidePromolines: false,
  hideBadges: false,
  hideWishlist: false
}

const SkeletonImage = () => {
  return (
    <div class="relative w-full aspect-4/5 bg-page-secondary overflow-hidden animate-pulse">
    </div>
  )
}

const SkeletonSwatches = () => {
  return (
    <div class="flex gap-x-0.375">
        {
          [1, 2, 3].map((i) => (
            <button key={i} class="size-0.75 bg-page-secondary overflow-hidden" aria-label="Swatch" disabled>
            </button>
          ))
        }
    </div>
  )
}

const SkeletonDetails = () => {
  return (
    <div class="flex flex-col gap-y-0.5">
      <div className={'h-1.125 bg-page-secondary'}></div>
      <div className={'h-1.125 bg-page-secondary'}></div>
    </div>
  )
}

const SkeletonPromolines = () => {
  return (
    <div class="flex flex-col gap-0.25">
      <div className={'w-1/2 h-1.25 bg-page-secondary'}></div>
      <div className={'w-1/2 h-1.25 bg-page-secondary'}></div>
    </div>
  )
}

// Mirrors CompactResultCard: aspect-[245/169], 50/50 image/details split,
// no swatches or promolines. Keeps the skeleton the same height as the real
// compact card so no white space is reserved below it.
const CompactSkeletonCard = ({ className }) => {
  return (
    <div class={clsx('w-full grow', className)}>
      <div class="flex aspect-[245/169] w-full overflow-hidden rounded-lg animate-pulse">
        <div class="h-full w-1/2 shrink-0 bg-page-secondary"></div>
        <div class="flex h-full w-1/2 shrink-0 flex-col gap-y-0.375 bg-page-secondary p-1">
          <div class="h-1.125 w-full bg-brand-paper"></div>
          <div class="h-1.125 w-1/2 bg-brand-paper"></div>
          <div class="mt-auto h-1.75 w-full bg-brand-paper"></div>
        </div>
      </div>
    </div>
  )
}

export const SkeletonCard = ({ className, options = DEFAULT_OPTIONS }) => {
  if (options.layout === 'compact') {
    return <CompactSkeletonCard className={className} />
  }

  return (
    <div class={clsx('flex flex-col gap-y-0.625 w-full grow', className)}>
        <SkeletonImage />
        <div class="flex flex-col gap-y-0.5 animate-pulse">
          {!options.hideSwatches && <SkeletonSwatches />}
          <SkeletonDetails />
          {!options.hidePromolines && <SkeletonPromolines />}
        </div>
    </div>
  )
}
